<div class="dashboard-page w100 bs-enabled content-holder" [ngClass]="{'is-admin' : isAdmin}" style="background: white;">
	<div class="flex-column page-inner-content-holder gap-3" style="background: white; position: relative;">
        <!--CC: pt-5 reservation removed - the tenant selector moved from floating over the content into the header-->
        <div class="flex-row flex-wrap-reverse align-items-center w-100 justify-content-between gap-3 rounded pt-1" style=" width: fit-content;">
            <div class="period-buttons-group flex-row gap-2" style="flex-shrink:0; min-width: 365px;">
                <button class="period-button bs-btn bs-btn-light h-100"
                        style="min-width: 75px;"
                        *ngFor="let item of dashboardPeriod | keyvalue: gs.returnZero"
                        [ngClass]="{'chosen' : period.value === item.value.value, 'disabled': batchInProcess}"
                        (click)="changePeriod(item.value);">
                    <span class="w-100 text-center">{{item.value.display}}</span>
                </button>

				<btn-c variant="text" color="danger"
					   style="min-width: 0;"
					   *ngIf="showAbortLoadingEmailsLabel"
					   (action)="abortLoadingEmails();">
					Abort
				</btn-c>
            </div>
			<div class="pe-2 py-1 rounded gap-2 d-flex align-items-center overflow-auto flex-shrink-0 border" *ngIf="quickAccessPages.length">
				<div class="flex-shrink-0 position-sticky d-flex align-items-center px-2" style="left: 0; height: 30px; background-color: white;">
					<span class="fw-bold">Quick Access:</span>
				</div>
				<div class="flex-row gap-4 align-items-center w-100" style="min-width: max-content;">
					<!--Page card-->
					<div *ngFor="let page of quickAccessPages"
						 class="blue-link flex-row align-items-center gap-1 quickAccessCard" style="max-width: 182px; height: 30px;"
						 (click)="quickAccessNavigate(page.url)"
						 [tooltip]="page.sectionTitle + ' > ' + (page.tabTitle ? page.tabTitle : page.pageTitle)">
						<i *ngIf="page.iconClass" [ngClass]="page.iconClass" style="font-size: 1rem; flex-shrink: 0;"></i>
						<div class="image-icon" style="background: var(--ui-brand-text);"
							 [ngStyle]="{'mask-image' : 'url(\'../../images/' + 'double-hook.svg' + '\')', '-webkit-mask-image' : 'url(\'../../images/' + 'double-hook.svg' + '\')'}"
							 *ngIf="!page.iconClass">
						</div>
						<span class="fw-bold" style="font-size: 12px;">{{page.tabTitle ? page.tabTitle : page.pageTitle}}</span>
					</div>
				</div>
			</div>
        </div>
        <div class="bs-container p-0 text-center" id="homeChartsContainer" style="max-width: none !important;">

			<div *ngIf="isAdmin" class="bs-row g-4 mb-3">
				<!--Email Trace-->
				<div class="bs-col-6 bs-col-large-8 order-large-1 inbound-trends" style="height: clamp(350px,50vh,405px);">
					<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">

						<div class="flex-row justify-content-between">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold">Email Trends</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
							           tooltip='Shows the volume of emails processed by Trustifi over the selected time period, split by direction.<br>Inbound - emails received by your organization.<br>Outbound - emails sent from your organization.'></i>
								</div>
								<span *ngIf="!getEmailTraceStatsInProcess && usageData?.emailTrace?.total" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.emailTrace.total}} emails in the {{period.display}}<ng-container *ngIf="usageData.emailTrace.lastEmailAgo"><span class="fw-normal"> &middot; last email seen </span><span class="fw-normal" style="text-decoration: underline dotted; cursor: default;" tooltip="{{usageData.emailTrace.lastEmailAt | amDateFormat:'MMMM Do YYYY, h:mm A'}}">{{usageData.emailTrace.lastEmailAgo}}</span></ng-container></span>
							</div>
							<span *ngIf="!usageData?.emailTrace?.total && !getEmailTraceStatsInProcess">No data for selected time period</span>
							<!--CC: taken from home.component.html -> Outbound Trends refresh button-->
							<i *ngIf="!getEmailTraceStatsInProcess" class="far fa-sync" tooltip="Refresh" style="cursor: pointer;" (click)="getEmailTraceStats()"></i>
						</div>

						<apx-chart class="f-1-0 animated fadeIn"
				                   *ngIf="emailTraceTrendsChartOptions?.xaxis?.categories?.length && !getEmailTraceStatsInProcess"
				                   #emailTraceChart
				                   [series]="emailTraceTrendsChartOptions.series"
				                   [chart]="emailTraceTrendsChartOptions.chart"
				                   [plotOptions]="emailTraceTrendsChartOptions.plotOptions"
				                   [colors]="emailTraceTrendsChartOptions.colors"
				                   [dataLabels]="emailTraceTrendsChartOptions.dataLabels"
				                   [stroke]="emailTraceTrendsChartOptions.stroke"
				                   [yaxis]="emailTraceTrendsChartOptions.yaxis"
				                   [fill]="emailTraceTrendsChartOptions.fill"
				                   [xaxis]="emailTraceTrendsChartOptions.xaxis"></apx-chart>

						<!--loader / placeholder-->
						<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getEmailTraceStatsInProcess">
							<div class="flex-column text-center centralize f-1-0">
								<loader class="opacity-75 align-self-center" *ngIf="getEmailTraceStatsInProcess" height="100" width="100"></loader>
							</div>
						</div>
						<!--CC: empty state redesigned to represent both inbound and outbound traffic-->
						<div class="w100 border h100 inner-content flxClmn-center animated fadeIn" style="flex: 1 0; margin-top: 10px; padding: 15px; align-items: center;"
						     *ngIf="!emailTraceTrendsChartOptions?.xaxis?.categories?.length && !getEmailTraceStatsInProcess">
							<div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0; align-items: center;">
								<div class="flxClmn-evenly" style="flex: 1 0;">
                                    <span style="font-size: 1.3rem; font-weight: bold;">
                                        No email traffic for this period
                                    </span>
									<span class="opacity-75" style="font-size: 1rem;">
                                        Trustifi secures both directions of your email flow
                                    </span>
								</div>
								<div class="flxRow-center hSpace2" style="flex: 3 0; align-items: stretch; width: 100%; transform: scale(0.9);">
									<!--Inbound-->
									<!--CC: min-width 0 + shrinkable thumbnails so both halves fit the card width without clipping-->
									<div class="flxClmn-around vSpace1" style="flex: 1 0; align-items: center; min-width: 0;">
										<i class="far fa-envelope" style="font-size: 2.4rem; color: #1a4d99; opacity: 0.85;"></i>
										<span style="font-weight: bold; color: #1a4d99;">Inbound Shield™</span>
										<span class="opacity-75" style="font-size: 0.85rem;">Blocks viruses, phishing & ransomware</span>
										<div class="flxRow-center gap-2 threat-thumbnails-container" style="width: 100%;">
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<i class="threat-icon far fa-viruses"></i>
												<span class="threat-label" style="font-size: 0.8rem;">Viruses</span>
											</div>
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<img class="phishing-icon-img static-image-color" style="width: 35px;" src="images/hook.png">
												<span class="threat-label" style="font-size: 0.8rem;">Phishing</span>
											</div>
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<i class="threat-icon far fa-mask"></i>
												<span class="threat-label" style="font-size: 0.8rem;">Spoofing</span>
											</div>
										</div>
									</div>
									<!--CC: vertical divider between inbound and outbound-->
									<div style="width: 1px; align-self: stretch; background: rgba(0,0,0,0.1);"></div>
									<!--Outbound-->
									<div class="flxClmn-around vSpace1" style="flex: 1 0; align-items: center; min-width: 0;">
										<i class="far fa-paper-plane" style="font-size: 2.4rem; color: #2a9d38; opacity: 0.85;"></i>
										<span style="font-weight: bold; color: #2a9d38;">Outbound Protection</span>
										<span class="opacity-75" style="font-size: 0.85rem;">Encryption, DLP & compliance</span>
										<div class="flxRow-center gap-2 threat-thumbnails-container" style="width: 100%;">
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<i class="threat-icon far fa-lock"></i>
												<span class="threat-label" style="font-size: 0.8rem;">Encryption</span>
											</div>
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<i class="threat-icon far fa-user-shield"></i>
												<span class="threat-label" style="font-size: 0.8rem;">DLP</span>
											</div>
											<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; flex: 0 1 80px; min-width: 0;">
												<i class="threat-icon far fa-clipboard-check"></i>
												<span class="threat-label" style="font-size: 0.8rem;">Compliance</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div style="margin: 10px;">
								<btn-c variant="outlined" (action)="inboundDetails();">Learn More</btn-c>
							</div>
						</div>


					</div>
				</div>


				<!--Email Trends Totals-->
				<div class="bs-col-6 bs-col-large-4 order-large-1 inbound-trends" style="height: clamp(350px,50vh,405px);">
					<div class="trends-data-card flex-column gap-1 p-3 pt-2 animated fadeIn h-100 w-100">
						<div class="flex-row justify-content-center gap-3 f-1-0 animated fadeIn" *ngIf="!getEmailTraceStatsInProcess">
							<!--Inbound-->
							<div class="flex-column align-items-start f-1-0 gap-3">
								<div class="flex-row align-items-center gap-2 cursor-pointer" tooltip="Navigate to email trace to view all inbound emails" (click)="goToEmailTrace('inbound', '')">
									<img src="images/incoming-email.png" style="width: 2.4rem; height: 2.4rem; object-fit: contain; opacity: 0.85;">
									<div class="flex-column align-items-start">
										<h4 class="m-0">{{usageData?.emailTrace?.inbound.total || '0'}}</h4>
										<span class="opacity-75 fw-500 text-start" style="font-size: 0.8rem;">Inbound emails</span>
									</div>
								</div>
								<div class="flex-column f-1-0 w-100" style="font-size: 0.85rem;">
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('inbound', 'Completed')">
										<i class="far fa-check-circle" style="font-size: 1rem; color: var(--bs-success);"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Completed</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.inbound?.lastCompleted; else emptyLast">last email: {{emailTraceLastActivity.inbound.lastCompleted}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.inbound.completed || '0'}}</span>
									</span>
									<div style="height: 1px; background: rgba(0,0,0,0.08);"></div>
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('inbound', 'Quarantined')">
										<i class="far fa-shield static-color" style="font-size: 1rem; color: #6f42c1;"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Quarantined</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.inbound?.lastQuarantined; else emptyLast">last email: {{emailTraceLastActivity.inbound.lastQuarantined}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.inbound.quarantined || '0'}}</span>
									</span>
									<div style="height: 1px; background: rgba(0,0,0,0.08);"></div>
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('inbound', 'Failed')">
										<i class="far fa-times-circle" style="font-size: 1rem; color: var(--bs-danger);"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Failed</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.inbound?.lastFailed; else emptyLast">last email: {{emailTraceLastActivity.inbound.lastFailed}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.inbound.failed || '0'}}</span>
									</span>
								</div>
							</div>
							<div style="width: 1px; align-self: stretch; background: rgba(0,0,0,0.1);"></div>
							<!--Outbound-->
							<div class="flex-column align-items-start f-1-0 gap-3">
								<div class="flex-row align-items-center gap-2 cursor-pointer" tooltip="Navigate to email trace to view all outbound emails" (click)="goToEmailTrace('outbound', '')">
									<img src="images/outgoing-email.png" style="width: 2.4rem; height: 2.4rem; object-fit: contain; opacity: 0.85;">
									<div class="flex-column align-items-start">
										<h4 class="m-0">{{usageData?.emailTrace?.outbound.total || '0'}}</h4>
										<span class="opacity-75 fw-500 text-start" style="font-size: 0.8rem;">Outbound emails</span>
									</div>
								</div>
								<div class="flex-column f-1-0 w-100" style="font-size: 0.85rem;">
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('outbound', 'Completed')">
										<i class="far fa-check-circle" style="font-size: 1rem; color: var(--bs-success);"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Completed</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.outbound?.lastCompleted; else emptyLast">last email: {{emailTraceLastActivity.outbound.lastCompleted}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.outbound.completed || '0'}}</span>
									</span>
									<div style="height: 1px; background: rgba(0,0,0,0.08);"></div>
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('outbound', 'Quarantined')">
										<i class="far fa-shield static-color" style="font-size: 1rem; color: #6f42c1;"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Quarantined</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.outbound?.lastQuarantined; else emptyLast">last email: {{emailTraceLastActivity.outbound.lastQuarantined}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.outbound.quarantined || '0'}}</span>
									</span>
									<div style="height: 1px; background: rgba(0,0,0,0.08);"></div>
									<span class="flex-row align-items-center w-100 cursor-pointer f-1-0 gap-2" tooltip="Navigate to email trace to view emails" (click)="goToEmailTrace('outbound', 'Failed')">
										<i class="far fa-times-circle" style="font-size: 1rem; color: var(--bs-danger);"></i>
										<span class="flex-column align-items-start f-1-0">
											<span>Failed</span>
											<span class="opacity-75 text-start" style="font-size: 11px;"><ng-container *ngIf="emailTraceLastActivity?.outbound?.lastFailed; else emptyLast">last email: {{emailTraceLastActivity.outbound.lastFailed}}</ng-container></span>
										</span>
										<span class="fw-bold">{{usageData?.emailTrace?.outbound.failed || '0'}}</span>
									</span>
									<ng-template #emptyLast></ng-template>
								</div>
							</div>
						</div>
						<!--loader / placeholder-->
						<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getEmailTraceStatsInProcess">
							<div class="flex-column text-center centralize f-1-0">
								<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
							</div>
						</div>
					</div>
				</div>
			</div>


            <div class="bs-row g-4">
                <!--Inbound Trends-->
                <div class="bs-col-6 bs-col-large-4 order-large-1 inbound-trends" style="height: clamp(350px,50vh,405px);">
                    <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">

						<div class="flex-row justify-content-between">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold">Inbound Trends</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
									   tooltip='Shows the distribution of threats that were identified by Inbound Shield™ in the selected time period.<br>Quarantined - emails that were found to be suspicious/malicious and are pending a security review'></i>
								</div>
								<span *ngIf="!getInboundStatsInProcess && usageData?.inbound?.inboundStats?.total" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.inbound.inboundStats.total}} threats detected in the {{period.display}}</span>
							</div>
							<span *ngIf="!usageData?.inbound?.inboundStats?.total && !getInboundStatsInProcess">No data for selected time period</span>
							<i *ngIf="!getInboundStatsInProcess" class="far fa-sync" tooltip="Refresh" style="cursor: pointer;" (click)="getInboundStats(true)"></i>
						</div>

						<apx-chart class="f-1-0 animated fadeIn"
								   *ngIf="inboundTrendsChartOptions?.xaxis?.categories?.length && !getInboundStatsInProcess"
								   #inboundTrendsChart
								   [series]="inboundTrendsChartOptions.series"
								   [chart]="inboundTrendsChartOptions.chart"
								   [plotOptions]="inboundTrendsChartOptions.plotOptions"
								   [colors]="inboundTrendsChartOptions.colors"
								   [dataLabels]="inboundTrendsChartOptions.dataLabels"
								   [stroke]="inboundTrendsChartOptions.stroke"
								   [yaxis]="inboundTrendsChartOptions.yaxis"
								   [fill]="inboundTrendsChartOptions.fill"
								   [xaxis]="inboundTrendsChartOptions.xaxis"></apx-chart>

                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getInboundStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" *ngIf="getInboundStatsInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no inbound" placeholder-->
                        <div class="w100 border h100 inner-content flxClmn-center animated fadeIn" style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;"
                             *ngIf="!inboundTrendsChartOptions?.xaxis?.categories?.length && !getInboundStatsInProcess">
                            <div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        Inbound Shield™
                                    </span>
                                    <span style=" font-size: 1rem;">
                                        Protects your inbox from:
                                    </span>
                                </div>
                                <div class="flxClmn-center vSpace2" style="flex: 4 0; transform: scale(0.85);">
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-viruses"></i>
                                            <span class="threat-label">Viruses</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <img class="phishing-icon-img" style="width: 35px; opacity: 0.7;" src="images/hook.png">
                                            <span class="threat-label">Phishing</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; position: relative;">
                                            <i class="threat-icon fas fa-desktop"></i>
                                            <i class="threat-icon zmdi zmdi-lock-outline" style="position: absolute; font-size: 0.65rem; top: 4px; background: white;"></i>
                                            <span class="threat-label">Ransomware</span>
                                        </div>
                                    </div>
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-mask"></i>
                                            <span class="threat-label">Spoofing</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <div class="w100" style="position: relative;">
                                                <i class="threat-icon far fa-envelope"></i>
                                                <i class="far fa-exclamation-triangle" style="position: absolute; right: 12px; bottom: 0; font-size: 1rem; filter: brightness(0.5);"></i>
                                            </div>
                                            <span class="threat-label">Spam</span></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="inboundDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Inbound Threat Types-->
                <div class="bs-col-6 bs-col-large-4 order-large-4 inbound-trends2" style="height: clamp(350px,50vh,405px);">
                    <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">

						<div class="flex-row justify-content-between">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold">Inbound Threat Types</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
									   tooltip="The numbers indicate a total number of emails detected with this threat type. Actual numbers could be even greater since this does not include blocked emails as a result of blocklisting or preferences."></i>
								</div>
								<span *ngIf="!getInboundStatsInProcess && usageData?.inbound?.detectionType?.total" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.inbound.detectionType.total}} threats listed in the {{period.display}}</span>
							</div>
							<span class="align-self-center" *ngIf="!usageData?.inbound?.detectionType?.total && !getInboundStatsInProcess">No data for selected time period</span>
						</div>

                        <div class="flex-column f-1-0 centralize animated fadeIn" *ngIf="usageData?.inbound?.detectionType?.total && !getInboundStatsInProcess">
							<apx-chart class="pie-chart" style="width: 100%; max-width: 400px;"
									   #threatDetectionTypeChart
									   [series]="detectionTypeChartOptions.series"
									   [chart]="detectionTypeChartOptions.chart"
									   [plotOptions]="detectionTypeChartOptions.plotOptions"
									   [dataLabels]="detectionTypeChartOptions.dataLabels"
									   [colors]="detectionTypeChartOptions.colors"
									   [labels]="detectionTypeChartOptions.labels"></apx-chart>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getInboundStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no inbound" placeholder-->
						<div class="w100 border h100 inner-content flxClmn-center animated fadeIn" style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;"
							 *ngIf="!usageData?.inbound?.detectionType?.total && !getInboundStatsInProcess">
							<div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0;">
								<div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        Inbound Shield™
                                    </span>
									<span style=" font-size: 1rem;">
                                        Protects your inbox from:
                                    </span>
								</div>
								<div class="flxClmn-center vSpace2" style="flex: 4 0; transform: scale(0.85);">
									<div class="flxRow-center hSpace2 threat-thumbnails-container">
										<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
											<i class="threat-icon far fa-viruses"></i>
											<span class="threat-label">Viruses</span>
										</div>
										<div></div>
										<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
											<img class="phishing-icon-img" style="width: 35px; opacity: 0.7;" src="images/hook.png">
											<span class="threat-label">Phishing</span>
										</div>
										<div></div>
										<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; position: relative;">
											<i class="threat-icon fas fa-desktop"></i>
											<i class="threat-icon zmdi zmdi-lock-outline" style="position: absolute; font-size: 0.65rem; top: 4px; background: white;"></i>
											<span class="threat-label">Ransomware</span>
										</div>
									</div>
									<div class="flxRow-center hSpace2 threat-thumbnails-container">
										<div></div>
										<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
											<i class="threat-icon far fa-mask"></i>
											<span class="threat-label">Spoofing</span>
										</div>
										<div></div>
										<div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
											<div class="w100" style="position: relative;">
												<i class="threat-icon far fa-envelope"></i>
												<i class="far fa-exclamation-triangle" style="position: absolute; right: 12px; bottom: 0; font-size: 1rem; filter: brightness(0.5);"></i>
											</div>
											<span class="threat-label">Spam</span></div>
										<div></div>
									</div>
								</div>
							</div>
							<div style="margin: 10px;">
								<btn-c variant="outlined" (action)="inboundDetails();">Learn More</btn-c>
							</div>
						</div>
                    </div>
                </div>


                <!--Outbound Trends-->
                <div class="bs-col-6 bs-col-large-4 order-large-2 outbound-trends" style="height: clamp(350px,50vh,405px);">
                    <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
                        <div class="flex-row justify-content-between">
                            <div class="flex-column align-items-start gap-1">
                                <div class="flex-row align-items-center gap-1">
                                    <h6 class="m-0 fw-bold">Outbound Trends</h6>
                                    <i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                                       tooltip='Shows how many secure emails (which use "Encrypt Message Content" and/or "Require Authentication") were sent in selected time period out of the total emails sent using Trustifi'></i>
                                </div>
                                <span *ngIf="!getOutboundStatsInProcess && outboundTrendsChartOptions?.xaxis?.categories?.length" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.outbound.general.total}} sent emails in the {{ period.display}}</span>
                            </div>
                            <span *ngIf="!outboundTrendsChartOptions?.xaxis?.categories?.length && !getOutboundStatsInProcess">No data for selected time period</span>
							<i *ngIf="!getOutboundStatsInProcess" class="far fa-sync" tooltip="Refresh" style="cursor: pointer;" (click)="getOutboundStats(true)"></i>
                        </div>
						<apx-chart class="f-1-0 animated fadeIn" style="max-height: min(26vw,450px);"
								   *ngIf="outboundTrendsChartOptions?.xaxis?.categories?.length && !getOutboundStatsInProcess"
								   #outboundEmailsChart
								   [options]="{display: false}"
								   [series]="outboundTrendsChartOptions.series"
								   [chart]="outboundTrendsChartOptions.chart"
								   [plotOptions]="outboundTrendsChartOptions.plotOptions"
								   [colors]="outboundTrendsChartOptions.colors"
								   [dataLabels]="outboundTrendsChartOptions.dataLabels"
								   [xaxis]="outboundTrendsChartOptions.xaxis"
								   [yaxis]="outboundTrendsChartOptions.yaxis"
								   [fill]="outboundTrendsChartOptions.fill"
								   [tooltip]="outboundTrendsChartOptions.tooltip"
								   [stroke]="outboundTrendsChartOptions.stroke"></apx-chart>

						<!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getOutboundStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no outbound" placeholder-->
                        <div class="w100 h100 border inner-content flxClmn-center animated fadeIn" style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;"
                             *ngIf="!outboundTrendsChartOptions?.xaxis?.categories?.length && !getOutboundStatsInProcess">
                            <div class="animated flxClmn-around fadeIn w-100" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        {{corpname | Titleize}}'s Outbound Protection
                                    </span>
                                </div>
                                <div class="outbound-feature-thumbnails-container" style="flex: 4 0; transform: scale(0.85); display: grid; grid-template-columns: auto auto; justify-items: center; grid-gap: 8%;">
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon zmdi zmdi-lock-outline"></i>
                                        <span>Email & attachments encryption</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon far fa-key"></i>
                                        <span>Recipient Multi-Factor Authentication</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <span style="font-size: 1.3rem; font-family: 'Roboto Condensed'; letter-spacing: 0.8px;">Postmark™</span>
                                        <span>Exclusive legal proof of sending</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon fas fa-shield-alt"></i>
                                        <span>Advanced DLP rules and policies</span>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="outboundDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Outbound Rules Usage-->
                <div class="bs-col-6 bs-col-large-4 order-large-5 inbound-rules" style="height: clamp(350px,50vh,405px);" *ngIf="isAdmin">
                    <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">

						<div class="flex-row justify-content-between">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold">Outbound Rules Usage</h6>
								</div>
								<span *ngIf="outboundRulesChartOptions?.labels?.length" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.outbound.rules.total}} emails caught by outbound rules in the {{period.display}}</span>
							</div>
							<span class="align-self-center mt-1" *ngIf="!outboundRulesChartOptions?.labels?.length && !getOutboundStatsInProcess">No data for selected time period</span>
						</div>

                        <div class="flex-column f-1-0 centralize animated fadeIn position-relative" *ngIf="outboundRulesChartOptions?.labels?.length && !getOutboundStatsInProcess">
							<apx-chart class="pie-chart clickable-chart" style="width: 100%; max-width: 400px;"
									   #outboundRulesChart
									   [series]="outboundRulesChartOptions.series"
									   [chart]="outboundRulesChartOptions.chart"
									   [plotOptions]="outboundRulesChartOptions.plotOptions"
									   [dataLabels]="outboundRulesChartOptions.dataLabels"
									   [labels]="outboundRulesChartOptions.labels"></apx-chart>
                        </div>

                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getOutboundStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no outbound" placeholder-->
                        <div class="w100 h100 border inner-content flxClmn-center animated fadeIn" style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;"
                             *ngIf="!outboundRulesChartOptions?.labels?.length && !getOutboundStatsInProcess">
                            <div class="animated flxClmn-around fadeIn w-100" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        {{corpname | Titleize}}'s Outbound Protection
                                    </span>
                                </div>
                                <div class="outbound-feature-thumbnails-container" style="flex: 4 0; transform: scale(0.85); display: grid; grid-template-columns: auto auto; justify-items: center; grid-gap: 8%;">
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon zmdi zmdi-lock-outline"></i>
                                        <span>Email & attachments encryption</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon far fa-key"></i>
                                        <span>Recipient Multi-Factor Authentication</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <span style="font-size: 1.3rem; font-family: 'Roboto Condensed'; letter-spacing: 0.8px;">Postmark™</span>
                                        <span>Exclusive legal proof of sending</span>
                                    </div>
                                    <div class="flxClmn-center vSpace1 outbound-feature-thumbnail" style="align-items: center;">
                                        <i class="outbound-feature-icon fas fa-shield-alt"></i>
                                        <span>Advanced DLP rules and policies</span>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="outboundDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Account Takeover Incidents-->
                <div class="bs-col-6 bs-col-large-4 order-large-3 compromised-incidents" style="height: clamp(350px,50vh,405px);" *ngIf="isAdmin">
                    <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
<!--                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Account Takeover Incidents</h6>
                            </div>
                            <span *ngIf="!getCompromisedStatsInProcess && usageData?.compromisedStats?.totalIncidents" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.compromisedStats.totalIncidents}} incidents detected in the {{period.display}}</span>
                        </div>-->

						<div class="flex-row justify-content-between">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold">Account Takeover Incidents</h6>
								</div>
								<span *ngIf="!getCompromisedStatsInProcess && usageData?.compromisedStats?.totalIncidents" class="opacity-75 fw-500 text-start" style="height: 16px;">{{usageData.compromisedStats.totalIncidents}} incidents detected in the {{period.display}}</span>
							</div>
							<span class="align-self-center" *ngIf="!usageData?.compromisedStats?.totalIncidents && !getCompromisedStatsInProcess">No data for selected time period</span>
						</div>

						<apx-chart class="f-1-0 animated fadeIn"
								   *ngIf="usageData?.compromisedStats?.totalIncidents && !getCompromisedStatsInProcess"
								   [options]="{display: false}"
								   [series]="compromisedIncidentsChartOptions.series"
								   [chart]="compromisedIncidentsChartOptions.chart"
								   [plotOptions]="compromisedIncidentsChartOptions.plotOptions"
								   [dataLabels]="compromisedIncidentsChartOptions.dataLabels"
								   [stroke]="compromisedIncidentsChartOptions.stroke"
								   [fill]="compromisedIncidentsChartOptions.fill"
								   [tooltip]="compromisedIncidentsChartOptions.tooltip"
								   [xaxis]="compromisedIncidentsChartOptions.xaxis"></apx-chart>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getCompromisedStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no compromised" placeholder-->
                        <div style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;" class="w100 h100 border inner-content flxClmn-center animated fadeIn"
                             *ngIf="!usageData?.compromisedStats?.totalIncidents && !getCompromisedStatsInProcess">
                            <div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        Account Takeover Protection
                                    </span>
                                    <span style=" font-size: 1rem;">
                                        Detects suspicious activity:
                                    </span>
                                </div>
                                <div class="flxClmn-center vSpace2" style="flex: 4 0; transform: scale(0.85);">
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-map-marked-alt"></i>
                                            <span class="threat-label">Suspicious locations</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon fas fa-desktop"></i>
                                            <i class="threat-icon far fa-question" style="position: absolute; font-size: 0.65rem; top: 4px; background: white;"></i>
                                            <span class="threat-label">Unknown devices</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; position: relative;">
                                            <i class="threat-icon far fa-chart-line"></i>
                                            <span class="threat-label">Unusual activity</span>
                                        </div>
                                    </div>
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-user-secret"></i>
                                            <span class="threat-label">Dark web monitoring</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <div class="w100" style="position: relative;">
                                                <i class="threat-icon far fa-hand-paper"></i>
                                                <i class="threat-icon far fa-ban" style="position: absolute; right: 12px; bottom: 0; font-size: 1rem; filter: brightness(0.5);"></i>
                                            </div>
                                            <span class="threat-label">Unauthorized access</span></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="accountDetectionDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Users Location-->
                <div class="bs-col-6 bs-col-large-4 order-large-6 mailboxes-location" style="height: clamp(350px,50vh,405px);" *ngIf="isAdmin">
                    <div class="trends-data-card overflow-hidden flex-column justify-content-between animated fadeIn h-100 w-100"
                         [ngClass]="{'p-3' : !compromisedLocations}">
                        <div class="flex-column align-items-start gap-1 " style="z-index: 500; transition: all 0.2s;"
                             [ngClass]="{'fading-title p-3' : compromisedLocations}">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">User Activity Locations</h6>
                            </div>
                            <span class="opacity-75 fw-500 text-start" style="height: 16px;" *ngIf="compromisedLocations">Last locations where users have been active</span>
                        </div>
                        <div class="f-1-0" *ngIf="compromisedLocations?.last && !getCompromisedStatsInProcess">
                            <leaflet-c id="lastLocationsMap"
									   [markers]="compromisedLocations.last"
									   [heatmapData]="compromisedLayers.last.overlays.heatmap"
									   [leafletCenter]="leafletCenter.last"
									   height="100%" width="100%"></leaflet-c>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="(!compromisedLocations && userInfo?.plan?.account_compromised?.enabled) || getCompromisedStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <span class="fw-500 opacity-75" *ngIf="!getCompromisedStatsInProcess">No data for selected time period</span>
                                <loader class="opacity-75 align-self-center" *ngIf="getCompromisedStatsInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no compromised" placeholder-->
                        <div style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;" class="w100 h100 border inner-content flxClmn-center animated fadeIn"
                             *ngIf="!userInfo?.plan?.account_compromised?.enabled && !getCompromisedStatsInProcess">
                            <div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        Account Takeover Protection
                                    </span>
                                    <span style=" font-size: 1rem; ">
                                        Detects suspicious activity:
                                    </span>
                                </div>
                                <div class="flxClmn-center vSpace2" style="flex: 4 0; transform: scale(0.85);">
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-map-marked-alt"></i>
                                            <span class="threat-label">Suspicious locations</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon fas fa-desktop"></i>
                                            <i class="threat-icon far fa-question" style="position: absolute; font-size: 0.65rem; top: 4px; background: white;"></i>
                                            <span class="threat-label">Unknown devices</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; position: relative;">
                                            <i class="threat-icon far fa-chart-line"></i>
                                            <span class="threat-label">Unusual activity</span>
                                        </div>
                                    </div>
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-user-secret"></i>
                                            <span class="threat-label">Dark web monitoring</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <div class="w100" style="position: relative;">
                                                <i class="threat-icon far fa-hand-paper"></i>
                                                <i class="threat-icon far fa-ban" style="position: absolute; right: 12px; bottom: 0; font-size: 1rem; filter: brightness(0.5);"></i>
                                            </div>
                                            <span class="threat-label">Unauthorized access</span></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="accountDetectionDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Latest Audit Logs-->
                <div class="bs-col-7 latest-audit-logs" style="height: 615px; order: 7;" *ngIf="isAdmin">
                    <div class="trends-data-card">
                        <div class="flex-column p-4 gap-3 animated fadeIn h-100 w-100" *ngIf="usageData?.general?.auditLogs?.length && !getGeneralDataInProcess">
                            <div class="flex-column align-items-start">
                                <h6 class="m-0 fw-bold ">Latest Audit Logs</h6>
                            </div>
                            <div class="flex-column audit-logs text-start overflow-auto f-1-0">
                                <div class="headers" style="flex-shrink: 0;">
                                    <b style="flex: 0 1 100%;">Action</b>
                                    <b style="flex: 0 1 50%;">User</b>
                                    <b style="flex: 0 1 240px;">Created</b>
                                </div>
                                <div class="logs" *ngIf="usageData?.general?.auditLogs?.length" style="flex: 1 0;">
                                    <a class="log no-underline"
                                       *ngFor="let log of usageData.general.auditLogs | orderBy: '-created'"
                                       (click)="goToAuditLogs(log.audit_log_type)">
                                        <div class="text ellipsis" style="flex: 0 1 100%; padding-right: max(1.5vw,15px);  width: 1px;">{{log.action}}</div>
                                        <div class="text ellipsis" style="flex: 0 1 50%; padding-right: max(1.5vw,15px);  width: 1px;">{{log.admin}}</div>
                                        <div class="ellipsis" style="flex: 0 1 240px;">{{log.created | date: 'MM/dd/yyyy HH:mm'}}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column gap-3 p-3 animated fadeIn h-100 w-100" *ngIf="!usageData?.general?.auditLogs?.length || getGeneralDataInProcess">
                            <div class="flex-row gap-2 align-items-start">
                                <h6 class="m-0 fw-bold">Latest Audit Logs</h6>
                            </div>
                            <div class="flex-column text-center centralize f-1-0">
                                <span class="fw-500 opacity-75" *ngIf="!getGeneralDataInProcess">No audit logs</span>
                                <loader class="opacity-75 align-self-center" *ngIf="getGeneralDataInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Usage statistics (user only)-->
                <div class="bs-col-6 bs-col-large-4 licenses-usage" style="height: clamp(350px,50vh,405px);" *ngIf="!isAdmin">
                    <div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
                        <h6 class="m-0 fw-bold align-self-start">Usage Statistics</h6>
                        <div class="flex-column justify-content-around gap-4 f-1-0 py-3 animated fadeIn" *ngIf="!getGeneralDataInProcess">
                            <div class="flex-row justify-content-around w-100">
                                <div class="flex-row align-items-center gap-3">
                                    <i class="far fa-envelope" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
                                    <div class="flex-column align-items-start f-1-0 gap-1">
                                        <h4 class="m-0 fw-bold">{{usageData?.general?.emailsSentOpenStats?.sent || '0'}}</h4>
                                        <span class="opacity-75 fw-500 text-start">Sent emails</span>
                                    </div>
                                </div>
                                <div class="flex-row align-items-center gap-3">
                                    <i class="far fa-envelope-open" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
                                    <div class="flex-column align-items-start f-1-0 gap-1" >
                                        <h4 class="m-0 fw-bold" [ngClass]="{'text-success' : usageData?.general?.emailsSentOpenStats?.opened}">{{usageData?.general?.emailsSentOpenStats?.opened || '0'}}</h4>
                                        <span class="opacity-75 fw-500 text-start">Opened emails</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-column align-items-end gap-1" style=" margin-top: -10%;">
                                <hr class="w-100 mt-0">
                            </div>

                            <div class="flex-row justify-content-around w-100">
                                <div class="flex-row align-items-center gap-3">
                                    <i class="far fa-file" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
                                    <div class="flex-column align-items-start f-1-0 gap-1">
                                        <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.storage]"
                                           tooltip='Go to "My Storage" page'>
                                            <h4 class="m-0 fw-bold">{{usageData?.general?.generalStats?.attachments || '0'}}</h4>
                                        </a>
                                        <span class="opacity-75 fw-500 text-start">Attachments</span>
                                    </div>
                                </div>
                                <div class="flex-row align-items-center gap-3">
                                    <i class="far fa-users" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
                                    <div class="flex-column align-items-start f-1-0 gap-1" >
                                        <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.contacts]"
                                           tooltip='Go to "My Contacts" page'>
                                            <h4 class="m-0 fw-bold">{{usageData?.general?.generalStats?.contacts || '0'}}</h4>
                                        </a>
                                        <span class="opacity-75 fw-500 text-start">Contacts</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getGeneralDataInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <loader class="opacity-75 align-self-center" *ngIf="getGeneralDataInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Devices list (user only)-->
                <div class="bs-col-12 bs-col-large-8 licenses-usage" style="height: clamp(350px,50vh,405px);" *ngIf="!isAdmin">
                    <div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
                                <div class="flex-row align-items-center gap-1">
                                    <h6 class="m-0 fw-bold">User Devices</h6>
                                </div>
                        <span class="opacity-75 fw-500 text-start" style="height: 16px;">List of devices from which you have connected to your account</span>

                        <div class="flex-column f-1-0 mt-2 p-2 pt-0 animated fadeIn overflow-auto" *ngIf="usageData?.compromisedStats?.devices?.length && !getCompromisedStatsInProcess">
                            <table class="w-100 table table-hover text-start" style="background: #fdfdfd;">
                                <thead><tr>
                                    <th style="width:35%;">Client</th>
                                    <th style="width:20%;">Location</th>
                                    <th style="width:20%;">IP Address</th>
                                    <th style="width:25%;">Last Used</th>
                                </tr></thead>
                                <tbody>
                                <tr *ngFor="let device of usageData.compromisedStats.devices | orderBy: '-last_used'">
                                    <td>
                                        <span *ngIf="device.agent && device.agent.browser">{{device.agent.browser.name + ' (' + device.agent.browser.version + '), ' + device.agent.os.name + ' (' + device.agent.os.version + ')'}}</span>
                                        <span *ngIf="device.agent && device.agent.raw && !device.agent.browser">{{device.agent.raw.ua || 'N/A'}}</span>
                                    </td>
                                    <td>
                                        <span *ngIf="device.location && device.location[0]">{{device.location[0].country}}{{device.location[0].city ? (', ' + device.location[0].city) : ''}}</span>
                                        <img style="cursor: pointer;" *ngIf="device.location[0] && device.location[0].ll" (click)="openLocation(device.location[0].ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACoFBMVEUAAADdSj7cSz7dSz7dSz7dSz7dSj7dSz7fTUDoRkbdSj3dSz7dSz7dSz7fQEDbSTfdSz7mTTPdSz7eSj43pWc0pmg0pmjdSz7eTD00pmndTD40pmjdSj7dSz7cTD3bTED/AADfSjzdTD7NU0PVVSuOooaQuaKYv6nI3dHW0lSz1cOXu27azGSrzNLdSz40pmhfj13cSz7cSz2fbE3bSj2kOTCDLiimOTFDrXNmvI1TtH84qGvEWUSvPDKALSezPTQ3p2qk17v8/v3////q9vBju4vRUUGaNS2dNy+X0bG74cx1w5mIy6a64cs+q3DBWkatOzKxPTNAq3H5/fu74c2jak3aSj2fOC+BLSiiODDbSj5huol5xJxYtoPk8+ux3cVgjl3ZSj3ZSj5UtICQzqxKsHmg1bmi1rr9/v2w3MQ1pWi4X0fV7ODv+PNct4Y2p2ma07SEyaNVr2TLxlTbTj5VtYHr9vD9/v7g8ejw+PTM6dk5qGxXr2Tr11H93E/HrVrG5tW/49CIy6dVrmTq11L83FHJi11asGPt2FHdz3rUVEbUVETu2FHq03TEw8GkpJJcsGP93FHq1XfDw8PCw8K9cWC9cV5dsWPv2FD178zs6+vExMSqtqqptanv2FHr6c7r6+u1fGlismLy2VHo5srs7OymsKFjs2Lz2VDAvHx3nM3w9Pru7u7FxcW/wsDWVEXWUkW+wsBks2O/vHxdicRciMV2m87v8/m1fmpls2Lz2lC+u311ms7u8/mqm4enl4O9u37u8vno6+iuu69rtGH22lC8un9diMR0mc3w8PDGxsZstWH32lC8uX9wl8zr8Pjx8fG1t4Rwlszq8PdttWG0toTp7/f12VCxtIevs4lvlsz+///821Ctsoro7vfy9vpSRSY7AAAALnRSTlMALYvN5+bKiCgLnv38lQgOxQquoSXG/P42w5T64suiQAE3h+IGpaquyPFuVvzMdTvKwAAAAAFiS0dEQ2fQDWIAAAAHdElNRQfiBQ0JLhcq1/DgAAACB0lEQVQ4y23Q+VtMUQDG8cMoW/YlZcm+d28pyV4Osu9LtiGRiOw7g4pBqbgRsmXJvneI7IRCpaJV/hXnPWea7h33/eWe53w/z8ydIcRkDRpaGrm5N25CzNe0WXNFzKNFS7PeyqI417qNCWir6NaOkPYdOqr6+cniP0Q8PDsRL9W4ANwHDg0KGuaPkzfpjNvg4SNGOsAoXI8ewzcWJwvhdyGh4ygdP0GCibgOA5iEUxeAyXTK1GnTZ0gwE9ezAGbj1JWDOXPn6d5hPq4XLAwPX7QYp24cLKFL1WVWq3W5ACvkr4hYKZ8+HETSVerqqDXRawVYF6P/H9y74x3Wb4hVN26imwXYsnVbfffoQQC279i5azfdsxd9337bgXrQkwigBkcdPBQnenyCzXb4SF3v1dsBnLMftfEdOy57Yh/iAuxJ6CeSUyRI6esCUtFPnkrW0k6jn0lzAeln0c+dz9C0CwAXNSNIv4R+mdIrXGQqSqZmBFev4fuvU74bGVqWomQZwc1b6Lfv3IW4d//Bw0ePDeCJ6E+z2bPnUuTkaHrw4iV6bjZj7NVrId681QPZ36Fz8R7iw0cd+JSH/vkLk/sqRH6BE3z7jv6jrjNWWARRXOAAsv9kupWUSiFAmei/mGElv4XoB1COXsFcVig+oz/AAN4r2X+r4p9RPRBg0OCaP8xkVbV/fdH/AbDMRR6RNRSkAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTEzVDA5OjQ2OjIzKzAwOjAwGkGfCQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0xM1QwOTo0NjoyMyswMDowMGscJ7UAAAAASUVORK5CYII=" alt=""/>
                                    </td>
                                    <td>
                                        <span>{{device.location[0].ip}}{{device.location[0].connection ? (' (' + device.location[0].connection + ')') : ''}}</span>
                                    </td>
                                    <td>
                                        <time>{{device.last_used | date:'MM/dd/yyyy HH:mm' }}</time>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="(!usageData?.compromisedStats?.devices?.length && userInfo?.plan?.account_compromised?.enabled) || getCompromisedStatsInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <span class="fw-500 opacity-75" *ngIf="!getCompromisedStatsInProcess">No data available</span>
                                <loader class="opacity-75 align-self-center" *ngIf="getCompromisedStatsInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                        <!--"no compromised" placeholder-->
                        <div style="flex: 1 0; margin-top: 10px; padding: 10px; align-items: center;" class="w100 h100 border inner-content flxClmn-center animated fadeIn"
                             *ngIf="!userInfo?.plan?.account_compromised?.enabled && !getCompromisedStatsInProcess">
                            <div class="animated flxClmn-around fadeIn" style="text-align: center; flex: 1 0;">
                                <div style=" flex: 2 0;" class="flxClmn-evenly">
                                    <span style=" font-size: 1.3rem; font-weight: bold;">
                                        Account Takeover Protection
                                    </span>
                                    <span style=" font-size: 1rem; ">
                                        Detects suspicious activity:
                                    </span>
                                </div>
                                <div class="flxClmn-center vSpace2" style="flex: 4 0; transform: scale(0.85);">
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-map-marked-alt"></i>
                                            <span class="threat-label">Suspicious locations</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon fas fa-desktop"></i>
                                            <i class="threat-icon far fa-question" style="position: absolute; font-size: 0.65rem; top: 4px; background: white;"></i>
                                            <span class="threat-label">Unknown devices</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center; position: relative;">
                                            <i class="threat-icon far fa-chart-line"></i>
                                            <span class="threat-label">Unusual activity</span>
                                        </div>
                                    </div>
                                    <div class="flxRow-center hSpace2 threat-thumbnails-container">
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <i class="threat-icon far fa-user-secret"></i>
                                            <span class="threat-label">Dark web monitoring</span>
                                        </div>
                                        <div></div>
                                        <div class="flxClmn-center vSpace1 threat-thumbnail" style="align-items: center;">
                                            <div class="w100" style="position: relative;">
                                                <i class="threat-icon far fa-hand-paper"></i>
                                                <i class="threat-icon far fa-ban" style="position: absolute; right: 12px; bottom: 0; font-size: 1rem; filter: brightness(0.5);"></i>
                                            </div>
                                            <span class="threat-label">Unauthorized access</span></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin: 10px;">
                                <btn-c variant="outlined" (action)="accountDetectionDetails();">Learn More</btn-c>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Latest notifications (user only)-->
                <div class="bs-col-12 latest-audit-logs" style="height: clamp(350px,50vh,405px); order: 7;" *ngIf="!isAdmin">
                    <div class="trends-data-card">
                        <div class="flex-column p-4 gap-3 animated fadeIn h-100 w-100" *ngIf="usageData?.general?.notifications?.length && !getGeneralDataInProcess">
                            <div class="flex-column align-items-start">
                                <h6 class="m-0 fw-bold ">Latest Notifications</h6>
                            </div>
                            <div class="flex-column audit-logs text-start overflow-auto f-1-0">
                                <div class="headers" style="flex-shrink: 0;">
                                    <h3 class="section-label text f-1-0">Message</h3>
                                    <h3 class="section-label source" style="flex-basis: 130px;">Date</h3>
                                </div>
                                <div class="logs f-1-0 overflow-auto">
                                    <span class="log notif cursor-default" *ngFor="let notification of usageData.general.notifications | orderBy: '-created'">
                                            <div class="text ellipsis f-1-0" style="padding-right: max(1.5vw,15px);" [innerHTML]="notification.text"></div>
                                            <time class="source" style="flex-basis: 130px;">{{ notification.created | date:'MM/dd/yyyy HH:mm' }}</time>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!--actions menu-->
                        <div class="trends-card-actions-menu" (ngInit)="showLatestNotificationssMenu = false;">
                            <i class="fas fa-ellipsis-h" id="latestNotificationsMenuTrigger" tooltip="Menu"
                               (click)="showLatestNotificationssMenu = !showLatestNotificationssMenu"></i>
                            <div class="drop-menu" [ngClass]="{'active' : showLatestNotificationssMenu}">
                                <ul (clickOutside)="showLatestNotificationssMenu = false;"
                                    [exclude]="'#latestNotificationsMenuTrigger'">
                                    <li class="flex-row align-items-center" [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.accountDetailsPages.notifications]">
                                        <span>Go to notifications page</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column gap-3 p-3 animated fadeIn h-100 w-100" *ngIf="!usageData?.general?.notifications?.length || getGeneralDataInProcess">
                            <div class="flex-row gap-2 align-items-start">
                                <h6 class="m-0 fw-bold">Latest Notifications</h6>
                            </div>
                            <div class="flex-column text-center centralize f-1-0">
                                <span class="fw-500 opacity-75" *ngIf="!getGeneralDataInProcess">No notifications</span>
                                <loader class="opacity-75 align-self-center" *ngIf="getGeneralDataInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Licenses Usage (admin only)-->
                <div class="bs-col-5 licenses-usage" style="height: 615px; order: 8;" *ngIf="isAdmin">
                    <div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
                        <h6 class="m-0 fw-bold align-self-start">License Usage</h6>
                        <div class="flex-column gap-1 f-1-0 animated fadeIn" *ngIf="mailboxesMeterChartOptions && usersMeterChartOptions && !getGeneralDataInProcess">
                            <div class="flex-row px-2 justify-content-between align-items-center">
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 160px;">
                                    <h4 class="m-0 fw-bold text-success">{{usageData?.general?.planInfo?.threat_protection?.used_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Active Mailboxes (Inbound)</span>
                                    <span class="opacity-75 fw-500 text-start">Unused: <b>{{usageData.general?.planInfo?.threat_protection?.allowed_users - usageData?.general?.mailboxesCount}}</b></span>
                                </div>
                                <div class="flex-row f-1-0">
									<apx-chart  style=" max-width: 220px; width: 100%;"
												*ngIf="mailboxesMeterChartOptions"
											   [series]="mailboxesMeterChartOptions.series"
											   [chart]="mailboxesMeterChartOptions.chart"
											   [plotOptions]="mailboxesMeterChartOptions.plotOptions"
											   [colors]="mailboxesMeterChartOptions.colors"
											   [labels]="mailboxesMeterChartOptions.labels"></apx-chart>
                                </div>
                            </div>
                            <div class="flex-column align-items-end gap-1" style="margin-top: -3%;">
                                <a class="blue-link no-underline" [routerLink]="['/' + dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.mailboxes]">
                                    Manage mailboxes
                                </a>
                                <hr class="w-100 mt-0">
                            </div>
                            <div class="flex-row px-2 justify-content-between align-items-center">
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 160px;">
                                    <h4 class="m-0 fw-bold text-success">{{usageData?.general?.planInfo?.shared_plan?.used_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Active Users (Outbound)</span>
                                    <span class="opacity-75 fw-500 text-start">Unused: <b>{{usageData?.general?.planInfo?.shared_plan?.allowed_users - usageData?.general?.planInfo?.shared_plan?.used_users}}</b></span>
                                </div>
                                <div class="flex-row f-1-0">
									<apx-chart class="animated fadeIn" style=" max-width: 221px; width: 100%;"
											   *ngIf="usersMeterChartOptions"
											   [series]="usersMeterChartOptions.series"
											   [chart]="usersMeterChartOptions.chart"
											   [plotOptions]="usersMeterChartOptions.plotOptions"
											   [colors]="usersMeterChartOptions.colors"
											   [labels]="usersMeterChartOptions.labels"></apx-chart>
                                </div>
                            </div>
                            <div class="flex-column align-items-end gap-1" style=" margin-top: -3%;">
                                <a class="blue-link no-underline" [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.userManagement]">
                                    Manage users
                                </a>
                                <hr class="w-100 mt-0">
                            </div>
                            <div class="flex-column my-2 px-2 justify-content-center position-relative">
                                <div class="flex-row justify-content-between" style=" position: absolute; top: 5px; width: 100%; padding: 0 27px;">
                                    <span class="opacity-75 fw-bold text-start" >Plan Storage Usage</span>
                                    <span style="font-size: 0.9rem; font-weight: bold;" [ngStyle]="{'color' : totalStorageUsage > maxStorageCapacity ? 'var(--bs-danger)' : '#939393'}">
                                        {{(totalStorageUsage) | FormatBytes:0}} / {{(maxStorageCapacity) | FormatBytes:0}}
                                    </span>
                                </div>
								<apx-chart class="animated fadeIn storage-usage-chart" style="width: 100%; max-height: 100px;"
										   [options]="{display: false}"
										   *ngIf="storageUsageBarOptions"
										   [series]="storageUsageBarOptions.series"
										   [chart]="storageUsageBarOptions.chart"
										   [plotOptions]="storageUsageBarOptions.plotOptions"
										   [colors]="storageUsageBarOptions.colors"
										   [grid]="storageUsageBarOptions.grid"
										   [fill]="storageUsageBarOptions.fill"
										   [xaxis]="storageUsageBarOptions.xaxis"
										   [yaxis]="storageUsageBarOptions.yaxis"
										   [legend]="storageUsageBarOptions.legend"
										   [tooltip]="storageUsageBarOptions.tooltip"
										   [dataLabels]="storageUsageBarOptions.dataLabels"></apx-chart>
                            </div>
                            <div class="flex-column align-items-end gap-1" style="margin-top: 20px;">
                                <hr class="w-100 mt-0">
                            </div>
                            <div class="flex-column align-items-start gap-1">
                                <h6 class="m-0 fw-bold" [ngClass]="{'text-danger' : isExpiredSoon}">{{usageData?.general?.planInfo?.expired | amDateFormat:'MMMM Do YYYY'}}</h6>
                                <span class="opacity-75 fw-500 text-start">Plan expiration date</span>
                            </div>

                            <btn-c class="align-self-end"
                                 variant="outlined"
                                 (action)="goToMyPlan();">
                                Upgrade plan
                            </btn-c>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!mailboxesMeterChartOptions || !usersMeterChartOptions || getGeneralDataInProcess">
                            <div class="flex-column text-center centralize f-1-0">
                                <span class="fw-500 opacity-75" *ngIf="!getGeneralDataInProcess">No data available</span>
                                <loader class="opacity-75 align-self-center" *ngIf="getGeneralDataInProcess" height="100" width="100"></loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--rule usage popup-->
    <outbound-rule-usage-c
            *ngIf="ruleUsagePopupData && ruleUsagePopupData?.show"
            [data]="ruleUsagePopupData">
    </outbound-rule-usage-c>

</div>
